import { render, staticRenderFns } from "./creareBuilding.vue?vue&type=template&id=46b802a0&scoped=true"
import script from "./creareBuilding.vue?vue&type=script&lang=js"
export * from "./creareBuilding.vue?vue&type=script&lang=js"
import style0 from "./creareBuilding.vue?vue&type=style&index=0&id=46b802a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b802a0",
  null
  
)

export default component.exports